var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"md-use px-3 text-md-center",attrs:{"id":_vm.howToUse.id}},[_c('h2',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.howToUse.title))]),_c('p',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.howToUse.description))]),_c('Carousel',{attrs:{"slides":_vm.howToUse.carousel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }